// ** React
import { FocusEvent, useRef, useState } from "react"

// ** Gatsby
import { Link } from "gatsby"

// ** Utils
import { parseLink } from "../../utils/helpers"

type linksType = {
  id: string
  url?: string
  reference?: {
    title: string
    slug: {
      current: string
    }
  }
  title: string
}

interface NestedNavigationItemMobileProps {
  title: string
  links: linksType[]
}

const activeStyles = {
  color: "#DD944B",
}

function NestedNavigationItemMobile(props: NestedNavigationItemMobileProps) {
  const subMenuRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<string>("0px")
  const { title, links } = props
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <div
      className="relative"
      onFocus={(e: FocusEvent<HTMLDivElement>) => {
        e.preventDefault()
        setIsOpen(true)
        if (subMenuRef && subMenuRef.current) {
          setHeight(`${subMenuRef.current.scrollHeight}px`)
        }
      }}
      onBlur={(e: FocusEvent<HTMLDivElement>) => {
        e.preventDefault()
        setIsOpen(false)
        setHeight("0px")
      }}
    >
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => {
          setIsOpen(!isOpen)
          if (isOpen) {
            setHeight("0px")
          } else {
            if (subMenuRef && subMenuRef.current) {
              setHeight(`${subMenuRef.current.scrollHeight}px`)
            }
          }
        }}
      >
        <Link
          to="#"
          className="text-gray-700 hover:text-blue-500 block py-4 rounded-md text-2xl font-extrabold"
        >
          {title}
        </Link>
        <svg
          className={`h-4 w-4 transform ${
            isOpen ? "rotate-180" : "rotate-0"
          } duration-700 align-middle fill-gray-800`}
          viewBox="0 0 14 8"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          style={{ transform: `${isOpen ? "scale(1, -1)" : ""}` }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.293.293a1 1 0 0 1 1.414 0L7 5.586 12.293.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z"
          ></path>
        </svg>
      </div>
      <div
        ref={subMenuRef}
        style={{ maxHeight: `${height}` }}
        className="block w-full overflow-y-hidden transition-max-height duration-700 ease-in-out border-b border-b-gray-300 "
      >
        <div className="pt-2 px-0 py-6">
          {links?.length > 0 &&
            links.map((link, idx) => (
              <div key={idx} className="flex justify-start py-[10px]">
                <Link
                  to={parseLink(link)}
                  activeStyle={activeStyles}
                  className="text-gray-700 hover:text-blue-500 hover:underline hover:cursor-pointer text-xl font-normal"
                >
                  {link.title}
                </Link>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default NestedNavigationItemMobile
